.reason-container{border:1px solid #dadada;border-radius:38px}.reason-container .divider{color:#a0a1a3;margin:0}
/*# sourceMappingURL=reason-for-report.component-PASGKHDH.css.map */
